import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

type SetError = (msg: string | undefined) => void;
type SetSubmitting = (isSubmitting: boolean) => void;

export function useAjaxFormSubmit() {
  const history = useHistory();

  return useCallback(
    (
      operation: (url: string, body: string) => { subscribe: Function },
      url: string,
      values: any,
      setError: SetError,
      setSubmitting: SetSubmitting
    ) => {
      operation(url, JSON.stringify(values)).subscribe({
        next: (response: AjaxResponse<any>) => {
          setSubmitting(false);
          if (response.status === 200 || response.status === 201) {
            history.goBack();
          } else {
            setError(JSON.stringify(response.response));
          }
        },
        error: (err: AjaxError) => {
          setError(err.response?.message ? err.response.message : err.message);
          setSubmitting(false);
        },
      });
    },
    [history]
  );
}